// Depends on assets/constants.warehouse.js (STOCK_GROUPS, TIERS, LOCATION_MAP) — must be loaded before this script.


let stockLevels = null;
let lastFetchedVariantId = null;

const resolveStockDisplay = (qty) => {
    if (!stockLevels) return;

    const msg = window.theme.strings.product.stockAvailability;
    const stockValueEl = document.querySelector("#general-product-stock-value");
    const warehouseInput = document.querySelector(
        "input[name='properties[_warehouse]']",
    );

    document
        .querySelectorAll(".main-product__stock-product span")
        .forEach((s) => (s.style.display = "none"));
    stockValueEl.classList.remove("stock-status-green", "stock-status-red");

    let cumulative = 0;
    const tier = TIERS.find((t) => (cumulative += stockLevels[t.key]) >= qty);

    if (tier) {
        document.querySelector(
            `.data-product-stock-${tier.cls}`,
        ).style.display = "block";
        stockValueEl.classList.add("stock-status-green");
        stockValueEl.innerHTML = msg[tier.msg];
        warehouseInput.value = tier.wh;
    } else if (stockLevels.onDemand > 0) {
        document.querySelector(".data-product-stock-on-demand").style.display =
            "block";
        stockValueEl.classList.add("stock-status-green");
        stockValueEl.innerHTML = msg.on_demand;
        warehouseInput.value = "OnDemandStock";
    } else {
        document.querySelector(".data-product-stock-out").style.display =
            "block";
        stockValueEl.classList.add("stock-status-red");
        stockValueEl.innerHTML = window.theme.strings.product.unavailable;
        warehouseInput.value = "undefined";
    }
};

const fetchStockForVariant = async (variantId) => {
    const container = document.querySelector(".main-product__stock-product");
    let decoded;
    try {
        decoded = await fetch(
            `${_ENDPOINT_}/public/product/delivery?shop=${Shopify.shop}&variantId=${variantId}`,
        ).then((r) => r.json());
    } catch (e) {
        return;
    }

    if (decoded.code != 200) return;

    stockLevels = {
        ...Object.fromEntries(Object.values(LOCATION_MAP).map((k) => [k, 0])),
        onDemand: 0,
    };
    for (const { node } of decoded.data.inventoryItem.inventoryLevels.edges) {
        const locationName = node.location.name?.toUpperCase();
        const qty =
            node.quantities.find((q) => q.name === "available")?.quantity ?? 0;
        const key = LOCATION_MAP[locationName];
        if (key) {
            stockLevels[key] = qty;
        } else if (locationName === "ON DEMAND") {
            stockLevels.onDemand = qty;
        }
    }

    // Populates the [data-stock-key] spans rendered by snippets/stock-custom-details.liquid
    for (const [group, tiers] of Object.entries(STOCK_GROUPS)) {
        const total = tiers.reduce(
            (sum, t) => sum + (stockLevels[t.key] ?? 0),
            0,
        );
        const el = document.querySelector(`[data-stock-key="${group}"]`);
        if (el) el.textContent = total;
    }

    const qty = parseInt(
        document.querySelector(".quantity__input")?.value || "1",
        10,
    );
    resolveStockDisplay(qty);

    document.querySelector(".stock-custom-row").style.display = "block";
    container.style.display = "block";
};

const getProductStockStatus = async () => {
    const container = document.querySelector(".main-product__stock-product");
    if (!container) {
        window.setTimeout(getProductStockStatus, 500);
        return;
    }

    const form = document.querySelector(".main-product__form-form");

    // Quantity buttons: scoped to this form, read value after stepUp/stepDown
    form?.querySelectorAll(".quantity__button").forEach((btn) => {
        btn.addEventListener("click", () => {
            requestAnimationFrame(() => {
                const qty = parseInt(
                    form.querySelector(".quantity__input")?.value || "1",
                    10,
                );
                resolveStockDisplay(qty);
            });
        });
    });

    // Variant change
    form?.addEventListener("change", (e) => {
        if (e.target.name === "quantity") return;
        requestAnimationFrame(() => {
            const newId = form.querySelector('input[name="id"]')?.value;
            if (newId && newId !== lastFetchedVariantId) {
                lastFetchedVariantId = newId;
                fetchStockForVariant(newId);
            }
        });
    });

    lastFetchedVariantId = container.getAttribute("data-variant-id");
    await fetchStockForVariant(lastFetchedVariantId);
};

const bootstrapReadMoreAnchor = () => {
    const cta = document.querySelector("#product_details");
    if (!cta) {
        window.setTimeout(bootstrapReadMoreAnchor, 350);
        return;
    }
    cta.addEventListener("click", (e) => {
        e.preventDefault();
        window.scrollTo({
            top:
                document.querySelector("#section-accordions__container")
                    .offsetTop - 75,
            behavior: "smooth",
        });
    });
};

getProductStockStatus();
bootstrapReadMoreAnchor();
